import React from "react";
import { GET_LIST, Title, Link } from "react-admin";
import { Card, CardContent, Paper, Button } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import styled from "styled-components";
import { prop, filter, map, curry, merge, range, isNil, length } from "ramda";
import * as R from "ramda"
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import LinearProgress from "@material-ui/core/LinearProgress";
import ReactToPrint from "react-to-print";
import Print from "@material-ui/icons/Print";
import { API_ROOT } from "../api-config";
import ElasticGrid from "./elasticGrid";


const ElasticColumn = styled.div({
  marginLeft: "5px",
  marginRight: "5px",
  flexGrow: 1,
  flexBasis: "50%"
});

const DayHeader = styled.div({
  textAlign: "center",
  display: "flex",
  flexDirection: "row"
});

const DayHeaderColumn = styled.div({
  textAlign: "center",
  justifyContent: "center",
  display: "flex",
  flexGrow: "1",
  flexDirection: "column"
});

const DayHeaderColumnFixed = styled.div({
  textAlign: "center",
  paddingRight: "5px",
  justifyContent: "center",
  display: "flex",
  flexDirection: "column"
});

const DayColumn = styled(Paper)`
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

class WeekBoard extends React.Component {
  constructor() {
    super();
    this.offset = 0;
    this.componentRef = React.createRef();
  }

  async fetchLocations() {
    const dataProvider = await dataProviderFactory("rest");
    const locations = await dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    const baseLocations = filter(location => {
      return isNil(location.base_location_id);
    }, locations.data);

    return baseLocations;
  }

  async fetchData(start_from, start_to, end_from, end_to, city) {
    const dataProvider = await dataProviderFactory("rest");

    const response = await dataProvider(GET_LIST, this.props.resource, {
      filter: merge(
        {
          start_from: start_from.format("YYYYMMDD"),
          start_to: start_to.format("YYYYMMDD"),
          end_from: end_from.format("YYYYMMDD"),
          end_to: end_to.format("YYYYMMDD"),
          city: city
        },
        this.props.filter || {}
      ),
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.dateField, order: "DESC" }
    });
    //console.log(response.data)
    return response.data;
  }

  async componentDidMount() {
    this.locations = await this.fetchLocations();
    this.currentLocation = 4;
    const today = moment();
    await this.updateStateForDate(today, this.currentLocation);
  }

  getTimeInterval = date => ({
    start: date.clone().startOf("isoWeek"),
    end: date
      .clone()
      .startOf("isoWeek")
      .clone()
      .add(7, "days")
  });

  updateStateForDate = async (dates, city) => {
    const date = moment.utc(dates)
    const { start, end } = this.getTimeInterval(date);
    const data = await this.fetchData(start, end, start, end, city);
    this.setState({ date, data });
  };

  nextClick = async () => {
    const date = (this.state.date || moment()).clone().add(1, "weeks");
    this.offset += 1;
    await this.updateStateForDate(date, this.currentLocation);
  };

  backClick = async () => {
    const date = (this.state.date || moment()).clone().subtract(1, "weeks");
    this.offset -= 1;

    await this.updateStateForDate(date, this.currentLocation);
  };

  renderCard = data => <this.props.card {...data} />;

  renderDayColumn = day => {
    const isSameDay = t => {
      const transferDate = moment.utc(prop("transfer_date", t) || null);
      const GuideBikeDate = moment.utc(prop("tour_start_date", t) || null);
      return (
        day.isSame(moment.utc(prop("date_2", t))) ||
        day.isSame(moment.utc(prop("date_1", t))) ||
        day.format("DD-MM-YYYY") === transferDate.format("DD-MM-YYYY") ||
        day.format("DD-MM-YYYY") === GuideBikeDate.format("DD-MM-YYYY")
      );
    };
    const isSameDayForRentals = (rental) => {
      let filterDate2 = rental.type === 1 
        ? moment.utc(prop("effective_end_date", rental.booking.tour)) 
        : moment.utc(prop("date_2", rental))

      return(
        day.isSame(filterDate2) ||
        day.isSame(moment.utc(prop("date_1", rental)))
      )
    }
    //console.log(this.state.data.guideBike)
    const dayData = filter(isSameDayForRentals, this.state.data.rentals)
    const dayDataTransfers = filter(isSameDay, this.state.data.transfers.rows);
    const dayDataGuide = filter(isSameDay, this.state.data.guideBike);
    //console.log(dayDataGuide)
    //console.log(dayDataTransfers)
    return this.renderCard({
      guideBike: dayDataGuide,
      rentals: dayData,
      transfers: dayDataTransfers,
      day,
      location: this.currentLocation
    });
  };

  openPdfByRentalDayAndLocation = async (rentalDay, locationId, type) => {
    await fetch(
      `${API_ROOT}/generate_rental_contract/?type=${type}&location_id=${locationId}&day=${moment(rentalDay._d).format("YYYY-MM-DD")}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.token}`
        }
      }
    )
      .then(async res => {
        const file = await res.blob();

        var reader = new FileReader();
        reader.readAsDataURL(file); //Convert the blob from clipboard to base64
        reader.onload = function (event) {
          const pdfDoc = reader.result.replace("octet-stream", "pdf");
          let a = document.createElement("a");
          a.href = pdfDoc;

          a.download = `${type === 1 ? "tour" : "rental"}-${moment(
            rentalDay._d
          ).format("DD-MM-YYYY")}.pdf`;
          a.click();
          a.remove();
        };
      })

      .catch(err => {
        console.error(err);
      });
  };

  renderDayColumnHeader = date => {
    const isSameDay = t => {
      // const transferDate = moment(prop("transfer_date", t) || null);
      // const GuideBikeDate = moment(prop("effective_start_date", t) || null);
      return (
        date.isSame(moment.utc(prop("date_2", t))) ||
        date.isSame(moment.utc(prop("date_1", t)))
        // date.format("DD-MM-YYYY") === transferDate.format("DD-MM-YYYY") ||
        // date.format("DD-MM-YYYY") === GuideBikeDate.format("DD-MM-YYYY")
      );
    };

    const dayData = filter(isSameDay, this.state.data.rentals);
    // const dayDataTransfers = filter(isSameDay, this.state.data.transfers.rows);
    // const isSameDay = t => date.isSame(moment(prop("date_1", t)));
    // const dayData = filter(isSameDay, this.state.data.rentals);
    return (
      <DayHeader>
        <DayHeaderColumn>
          <div>{date.format("dddd")}</div>
          <div>{date.format("DD-MM-YYYY")}</div>
        </DayHeaderColumn>
        <DayHeaderColumnFixed>
          {length(dayData) > 0 && (
            <Link
              to="#"
              alt="View all Contracts"
              title="View all Contracts"
              style={{ float: "right", height: "25px" }}
              onClick={() =>
                this.openPdfByRentalDayAndLocation(
                  date,
                  this.currentLocation,
                  "all"
                )
              }
            >
              <Print style={{ height: "20px" }} />
            </Link>
          )}
        </DayHeaderColumnFixed>
      </DayHeader>
    );
  };

  handleChange = async event => {
    switch (event.target.name) {
      case "week":
        const date = moment().add(event.target.value, "weeks");
        this.offset = event.target.value;
        await this.updateStateForDate(date, this.currentLocation);
        break;
      case "city":
        this.currentLocation = event.target.value;
        await this.updateStateForDate(this.state.date, this.currentLocation);
        break;
      default:
        const defaultDate = moment().add(event.target.value, "weeks");
        this.offset = event.target.value;
        await this.updateStateForDate(defaultDate, this.currentLocation);
        break;
    }
    // console.log(event)
    // this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    if (this.state === null) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    const date = this.state.date.startOf("isoWeek");
    const add = (day, offset) => day.clone().add(offset, "days");
    const days = map(curry(add)(moment.utc(date).startOf("day")), range(0, 7));
    const todayF = moment(new Date(), "YYYY-MM-DD").startOf("day");
    const today = moment();
    const weeksLeft =
      today.isoWeeksInYear() -
      today.isoWeek() +
      today
        .clone()
        .add(1, "year")
        .isoWeeksInYear();

    const weeks = map(offset => {
      const t = moment().add(offset, "weeks");
      const string = `${t
        .clone()
        .startOf("isoWeek")
        .format("DD-MM-YYYY")} - ${t
          .clone()
          .endOf("isoWeek")
          .format("DD-MM-YYYY")}`;
      return (
        <MenuItem key={t} value={offset}>
          {string}
        </MenuItem>
      );
    }, range(0, weeksLeft + 1));

    const cities = map(location => {
      return (
        <MenuItem key={location.id} value={location.id}>
          {location.location_name}
        </MenuItem>
      );
    }, this.locations);

    let currentDateSelectValue = this.offset;
    if (currentDateSelectValue < 0) {
      currentDateSelectValue = 0;
    }

    return (
      <Card>
        <Button color="primary" onClick={this.backClick}>
          <ChevronLeft />
        </Button>
        <Button color="primary" onClick={this.nextClick}>
          <ChevronRight />
        </Button>
        <Select
          value={currentDateSelectValue}
          onChange={this.handleChange}
          inputProps={{
            name: "week",
            id: "week-simple"
          }}
        >
          {weeks}
        </Select>
        <Select
          value={this.currentLocation}
          onChange={this.handleChange}
          inputProps={{
            name: "city",
            id: "city-simple"
          }}
        >
          {cities}
        </Select>
        <ReactToPrint
          trigger={() => (
            <Button color="primary" onClick={this.nextClick} title="Print">
              <Print />
            </Button>
          )}
          content={() => this.componentRef.current}
        />
        <Title title={this.props.title} />
        <CardContent ref={this.componentRef}>
          <ElasticGrid>
            <ElasticColumn>
              <DayColumn
                style={{
                  border: days[0].isSame(todayF) ? "2px solid #FFFF00" : ""
                }}
              >
                {this.renderDayColumnHeader(days[0])}
                {this.renderDayColumn(days[0])}
              </DayColumn>
            </ElasticColumn>
            <ElasticColumn>
              <DayColumn
                style={{
                  border: days[1].isSame(todayF) ? "2px solid #FFFF00" : ""
                }}
              >
                {this.renderDayColumnHeader(days[1])}
                {this.renderDayColumn(days[1])}
              </DayColumn>
            </ElasticColumn>
            <ElasticColumn>
              <DayColumn
                style={{
                  border: days[2].isSame(todayF) ? "2px solid #FFFF00" : ""
                }}
              >
                {this.renderDayColumnHeader(days[2])}
                {this.renderDayColumn(days[2])}
              </DayColumn>
            </ElasticColumn>
            <ElasticColumn>
              <DayColumn
                style={{
                  border: days[3].isSame(todayF) ? "2px solid #FFFF00" : ""
                }}
              >
                {this.renderDayColumnHeader(days[3])}
                {this.renderDayColumn(days[3])}
              </DayColumn>
            </ElasticColumn>
            <ElasticColumn>
              <DayColumn
                style={{
                  border: days[4].isSame(todayF) ? "2px solid #FFFF00" : ""
                }}
              >
                {this.renderDayColumnHeader(days[4])}
                {this.renderDayColumn(days[4])}
              </DayColumn>
            </ElasticColumn>

            <ElasticColumn>
              <DayColumn
                style={{
                  border: days[5].isSame(todayF) ? "2px solid #FFFF00" : ""
                }}
              >
                {this.renderDayColumnHeader(days[5])}
                {this.renderDayColumn(days[5])}
              </DayColumn>
            </ElasticColumn>

            <ElasticColumn>
              <DayColumn
                style={{
                  border: days[6].isSame(todayF) ? "2px solid #FFFF00" : ""
                }}
              >
                {this.renderDayColumnHeader(days[6])}
                {this.renderDayColumn(days[6])}
              </DayColumn>
            </ElasticColumn>
          </ElasticGrid>
        </CardContent>
      </Card>
    );
  }
}

export default WeekBoard;



// WEBPACK FOOTER //
// ./src/components/weekBoard.js